import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	searchPlaceholder: {
		id: 'content-state.menu.v2.search-placeholder',
		defaultMessage: 'Search or add',
		description: 'The text is shown as placeholder text inside the search input field in the content state menu (v2) in the editor, prompting the user to search for an existing status or type a new one to add.',
	},
	defaultWorkflow: {
		id: 'content-state.menu.v2.default-workflow',
		defaultMessage: 'Default workflow',
		description: 'Section title for default/suggested statuses',
	},
	customStatuses: {
		id: 'content-state.menu.v2.custom-statuses',
		defaultMessage: 'Custom statuses',
		description: 'The text is shown as a section heading in the content state menu (v2) in the editor, grouping custom user-defined statuses below it.',
	},
	addCustomStatus: {
		id: 'content-state.menu.v2.add-custom-status.title',
		defaultMessage: 'Add as custom status',
		description: 'The text is shown on a button in the content state menu (v2) in the editor that allows the user to save the typed search text as a new custom status for the page.',
	},
	addCustomStatusDescription: {
		id: 'content-state.menu.v2.add-custom-status.description',
		defaultMessage: 'Only you can choose this',
		description: 'Button description for add custom status button',
	},
	addCustomStatusHeader: {
		id: 'content-state.menu.v2.add-custom-status-view.header',
		defaultMessage: 'Add custom status',
		description: 'The text is shown as the heading at the top of the add custom status sub-view within the content state menu (v2) in the editor, when the user is creating a new custom status.',
	},
	statusNamePlaceholder: {
		id: 'content-state.menu.v2.status-name.placeholder',
		defaultMessage: 'Status name',
		description: 'Placeholder for status name input in the status view dialog',
	},
	cancel: {
		id: 'content-state.menu.v2.cancel',
		defaultMessage: 'Cancel',
		description: 'The text is shown on a button in the add custom status sub-view of the content state menu (v2) in the editor. When clicked, it discards the new custom status and returns to the main status menu.',
	},
	save: {
		id: 'content-state.menu.v2.save',
		defaultMessage: 'Save',
		description: 'The text is shown on a button in the add custom status sub-view of the content state menu (v2) in the editor. When clicked, it saves the newly created custom status and applies it to the page.',
	},
	changeStatus: {
		id: 'content-state.menu.v2.change-status',
		defaultMessage: 'Change status',
		description: 'Header text when changing an existing status',
	},
	startApproval: {
		id: 'content-state.menu.v2.start-approval',
		defaultMessage: 'Start approval',
		description: 'Label for the start approval button in the in review status option',
	},
	approvalBetaTag: {
		id: 'content-state.menu.v2.color-picker.option.aria-label',
		defaultMessage: 'Beta',
		description: 'The text is shown as a badge label on a color picker option in the content state menu (v2) in the editor, indicating that the associated approval feature is currently in beta.',
	},
	colorPickerLabel: {
		id: 'content-state.menu.v2.color-picker.aria-label',
		defaultMessage: 'Color picker selector',
		description: 'Aria label for the add custom status color picker',
	},
	colorOption: {
		id: 'content-state.menu.v2.color-picker.option.aria-label',
		defaultMessage: 'Color option',
		description: 'Aria label for the add custom status color options within the color picker',
	},
});
